import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const authenticated = await auth.isAuthenticated();
  if (!authenticated) {
    return router.createUrlTree(['/initial']);
  }

  const user = await auth.getUser();
  if (auth.needsBirthdayCapture(user) && !state.url.startsWith('/capture-birthday')) {
    return router.createUrlTree(['/capture-birthday']);
  }
  return true;
};

export const captureBirthdayGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const authenticated = await auth.isAuthenticated();
  if (!authenticated) {
    return router.createUrlTree(['/initial']);
  }

  const user = await auth.getUser();
  if (!auth.needsBirthdayCapture(user)) {
    return router.createUrlTree([auth.getRedirectPath(user)]);
  }
  return true;
};
